import { configsByCorporateId } from 'modules/_custom/config/configsByCorporateId';
import { SocietyCorporateId } from 'types/Society';

export const isAdminEmailAllowed = (
  email: string,
  corporateId: SocietyCorporateId
) => {
  const config =
    configsByCorporateId[corporateId || SocietyCorporateId.DEFAULT];

  if (!config.hasAdminDomainsLimited) {
    return true;
  }

  const allowedDomains = config.allowedAdminEmailDomains || [];

  const emailDomain = email.split('@')[1];

  return allowedDomains.some((domain: string) => domain === emailDomain);
};
